import { render, staticRenderFns } from "./ContactCoordonnesList.vue?vue&type=template&id=27922b76"
import script from "./ContactCoordonnesList.vue?vue&type=script&lang=ts"
export * from "./ContactCoordonnesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports